export default __webpack_public_path__ + "static/media/circle.217c20e1.svg";